import { render, staticRenderFns } from "./OtherLogin.vue?vue&type=template&id=661296df&scoped=true&"
import script from "./OtherLogin.vue?vue&type=script&lang=js&"
export * from "./OtherLogin.vue?vue&type=script&lang=js&"
import style0 from "./OtherLogin.vue?vue&type=style&index=0&id=661296df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661296df",
  null
  
)

export default component.exports